import { Box, Stack } from '@mui/material';
import { List, Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const GoalsSelectPageSkeleton: FC = () => {
  return (
    <Page back insetEnabled={false}>
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <Text style={{ fontSize: '18px', textAlign: 'center' }}>Edit Goals</Text>
      </Stack>
      <List
        style={{
          background: 'var(--tgui--secondary_bg_color)',
          padding: 10,
          paddingBottom: '80px',
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Box sx={{ padding: '0 16px', marginBottom: '8px' }}>
            <Text style={{ fontSize: '14px', color: 'var(--tgui--hint_color)' }}>
              You can select up to 3 goals
            </Text>
          </Box>
        {[1, 2, 3, 4].map(i => (
          <ThemedSkeleton key={i} variant="rectangular" width="100%" height={45} sx={{ borderRadius: 2 }} />
        ))}
      </List>
    </Page>
  );
};

